export class UserCompanyRole {


    constructor(public companyName: string = null, public policyId: number = null, public role: number = null, public roleName = null, public status: string = null, public createdBy: string = null) {

    }
}